import { STATIC_SERVER_URL } from '../config/config';

export function getImageFileName(desktopImage) {
  return `${STATIC_SERVER_URL}/web/images/news/${desktopImage}`;
}
